import { render, staticRenderFns } from "./Contract-barcode.vue?vue&type=template&id=f4fb91a6"
import script from "./Contract-barcode.vue?vue&type=script&lang=js"
export * from "./Contract-barcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports